import React, { Component } from 'react';
import { truncate, humanize } from 'underscore.string';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import AddButton from '../../v2/buttons/AddButton';
import DeleteButton from '../../v2/buttons/DeleteButton';
import EditButton from '../../v2/buttons/EditButton';
import { CUSTOMER_TYPE } from '../../../constants/webhooks';
import { getWebhooks, createWebhook, deleteWebhook, updateWebhook, } from '../../../utils/UserWebAPIUtils';
import ToastStore from '../../../stores/ToastStore';
import CargomaticCard from '../../v2/card';
import CargomaticModal from '../../v2/modal';
import ConfirmModal from '../../ui/modals/ConfirmModal';
import LoadingCircle from '../../ui/LoadingCircle';
import Form from './Form';
import Badge from '../../v2/Badge';
import SessionStore from '../../../stores/SessionStore';
class Webhooks extends Component {
    constructor(props) {
        super(props);
        this.handleAddWebhook = () => {
            const { userId } = this.props;
            this.setState({
                webhook: getNewWebhook(userId),
                showFormModal: true,
            });
        };
        this.handleEditWebhook = (id) => () => {
            const webhook = this.findWebhook(id);
            this.setState({
                webhook,
                showFormModal: true,
            });
        };
        this.handleDeleteWebhook = (id) => () => {
            const webhook = this.findWebhook(id);
            this.setState({
                showConfirmModal: true,
                webhook,
            });
        };
        this.handleConfirmDeleteWebhook = async () => {
            this.setState({
                showConfirmModal: false,
            });
            const { t } = this.props;
            try {
                const { webhook: { _id }, } = this.state;
                await deleteWebhook(_id);
                ToastStore.addNotification({
                    title: t('WEBHOOK_SUCCESSFULLY_DELETED'),
                    body: '',
                    level: 'success',
                });
                this.setState((prevState) => {
                    const { items: currentItems, webhook } = prevState;
                    const index = findIndex(webhook._id, currentItems);
                    return {
                        webhook: null,
                        items: [
                            ...currentItems.slice(0, index),
                            ...currentItems.slice(index + 1),
                        ],
                    };
                });
            }
            catch (e) {
                ToastStore.addNotification({
                    title: t('PROBLEM_DELETING_WEBHOOK'),
                    body: '',
                    level: 'error',
                });
            }
        };
        this.handleHideConfirmModal = () => {
            this.setState({
                showConfirmModal: false,
                webhook: null,
            });
        };
        this.handleHideWebhookForm = () => {
            this.setState({
                showFormModal: false,
                webhook: null,
            });
        };
        this.handleSaveForm = async (webhook) => {
            const { t } = this.props;
            try {
                let result;
                const isNewWebhook = !webhook._id;
                if (isNewWebhook) {
                    result = await createWebhook(webhook);
                }
                else {
                    result = await updateWebhook(webhook);
                }
                const { entity: { webhook: item }, } = result;
                if (isNewWebhook) {
                    this.setState((prevState) => {
                        const { items: currentItems } = prevState;
                        return {
                            items: [...currentItems, item],
                            webhook: null,
                            showFormModal: false,
                        };
                    });
                }
                else {
                    this.setState((prevState) => {
                        const { items: currentItems } = prevState;
                        const index = findIndex(webhook._id, currentItems);
                        if (index === -1) {
                            return;
                        }
                        return {
                            webhook: null,
                            showFormModal: false,
                            items: [
                                ...currentItems.slice(0, index),
                                webhook,
                                ...currentItems.slice(index + 1),
                            ],
                        };
                    });
                }
                ToastStore.addNotification({
                    title: t('WEBHOOK_SAVED_SUCCESSFULLY'),
                    body: '',
                    level: 'success',
                });
            }
            catch (e) {
                ToastStore.addNotification({
                    title: t('PROBLEM_SAVING_WEBHOOK'),
                    body: '',
                    level: 'error',
                });
            }
        };
        this.state = {
            items: [],
            loaded: false,
            showConfirmModal: false,
            showFormModal: false,
            webhook: null,
        };
    }
    componentDidMount() {
        this.fetchWebhooks();
    }
    findWebhook(id) {
        return this.state.items.find((item) => item._id === id);
    }
    async fetchWebhooks() {
        const { t } = this.props;
        try {
            const result = await getWebhooks(this.props.userId);
            const { entity: { webhooks: items }, } = result;
            const webhooksList = (items || []).map((item) => (Object.assign(Object.assign({}, item), { type: item.type || CUSTOMER_TYPE.value })));
            let filteredList;
            if (!SessionStore.isAdmin()) {
                filteredList = webhooksList.filter((item) => item.type === CUSTOMER_TYPE.value);
            }
            else {
                filteredList = [...webhooksList];
            }
            this.setState({
                items: filteredList,
                loaded: true,
            });
        }
        catch (e) {
            ToastStore.addNotification({
                title: t('PROBLEM_LOADING_WEBHOOKS'),
                body: '',
                level: 'error',
            });
        }
    }
    renderForm() {
        if (!this.state.showFormModal) {
            return null;
        }
        return (React.createElement(Form, { accountType: this.props.accountType, webhook: this.state.webhook, onCancel: this.handleHideWebhookForm, onSave: this.handleSaveForm }));
    }
    renderItems() {
        const { loaded } = this.state;
        const { t } = this.props;
        if (!loaded) {
            return (React.createElement("div", { className: "p-6" },
                React.createElement(LoadingCircle, { text: t('LOADING_WEBHOOKS') })));
        }
        const { items } = this.state;
        if (items.length === 0) {
            return (React.createElement("div", { className: "px-6 pb-6" },
                React.createElement("p", { className: "mt-0 mb-4" }, t('NO_HOOKS')),
                React.createElement("button", { className: "button button-green", onClick: this.handleAddWebhook },
                    React.createElement("i", { className: "fa fa-plus mr-1`" }),
                    React.createElement("span", { className: "inline-block" }, t('CREATE_NEW_HOOK')))));
        }
        return (React.createElement("div", { className: "overflow-x-auto" },
            React.createElement("table", { className: "min-w-full default-table" },
                React.createElement("thead", null,
                    React.createElement("tr", { className: "" },
                        React.createElement("th", { className: "" }, t('URL')),
                        SessionStore.isAdmin() && React.createElement("th", null, t('TYPE')),
                        React.createElement("th", { className: "" },
                            t('ERROR'),
                            " %"),
                        React.createElement("th", { className: "" }, t('ACTION', { count: 2 })))),
                React.createElement("tbody", { className: "bg-white" }, items.map((item) => (React.createElement("tr", { key: item._id, className: "" },
                    React.createElement("td", { style: { width: '150px' }, className: "", title: item.url }, truncate(item.url, 20)),
                    SessionStore.isAdmin() && (React.createElement("td", null,
                        React.createElement(Badge, { color: item.type === 'customer' ? 'green' : 'gray' }, humanize(item.type)))),
                    React.createElement("td", { className: "" },
                        item.totalCount > 0 && (React.createElement("div", null,
                            React.createElement("span", { className: "inline-block" },
                                calculatePercentage(item.errorCount, item.totalCount),
                                "%"),
                            React.createElement("span", { className: "inline-block ml-2" },
                                "(",
                                item.errorCount,
                                ' ',
                                t('ERROR', { count: item.errorCount }),
                                ")"))),
                        item.totalCount === 0 && React.createElement("span", null, "-")),
                    React.createElement("td", { className: "" },
                        React.createElement("div", { className: "flex items-center -mx-2" },
                            React.createElement("div", { className: "px-2" },
                                React.createElement(EditButton, { title: t('EDIT_WEBHOOK'), onClick: this.handleEditWebhook(item._id) })),
                            React.createElement("div", { className: "px-2" },
                                React.createElement(DeleteButton, { onClick: this.handleDeleteWebhook(item._id), title: t('DELETE_WEBHOOK') })))))))))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(CargomaticCard, { removeHorizontalPadding: true, removeVerticalPadding: true, header: () => (React.createElement("div", { className: "flex items-center justify-between" },
                    React.createElement("h3", { className: "my-0 text-lg font-medium leading-6" }, t('WEBHOOK_other', { count: 2 })),
                    React.createElement(AddButton, { onClick: this.handleAddWebhook }))) }, this.renderItems()),
            this.state.showFormModal && (React.createElement(CargomaticModal, { show: this.state.showFormModal, onHide: this.handleHideWebhookForm, title: t('ADD_WEBHOOK') }, this.renderForm())),
            this.state.showConfirmModal && (React.createElement(ConfirmModal, { show: this.state.showConfirmModal, message: t('WEBHOOK_DELETION_CONFIRM'), title: t('CONFIRM_DELETION'), onConfirm: this.handleConfirmDeleteWebhook, onHide: this.handleHideConfirmModal }))));
    }
}
Webhooks.propTypes = {
    accountType: PropTypes.string,
    userId: PropTypes.string.isRequired,
};
function findIndex(targetId, items) {
    return items.findIndex((h) => h._id === targetId);
}
function getNewWebhook(account) {
    return {
        action: 'POST',
        url: 'https://',
        enabled: true,
        events: [],
        type: CUSTOMER_TYPE.value,
        account,
    };
}
function calculatePercentage(numerator, denominator) {
    return ((numerator / denominator) * 100).toFixed(0);
}
export default withTranslation()(Webhooks);
